export default __webpack_public_path__ + "static/media/videoCall.784c70ba.svg";